<script setup>
defineProps({
  type: {
    type: String,
    required: true,
    validator: (v) => ["positive", "neutral", "negative"].includes(v),
  },
  color: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <svg
    class="tonality-icon"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <circle
      cx="8"
      cy="8"
      r="7"
      :stroke="color"
      stroke-width="1.5"
      fill="none"
    />
    <circle
      cx="5.5"
      cy="6.5"
      r="1"
      :fill="color"
    />
    <circle
      cx="10.5"
      cy="6.5"
      r="1"
      :fill="color"
    />
    <path
      v-if="type === 'positive'"
      d="M5 10C5.5 11.5 6.5 12 8 12C9.5 12 10.5 11.5 11 10"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      v-else-if="type === 'neutral'"
      d="M5.5 10.5H10.5"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      v-else-if="type === 'negative'"
      d="M5 11.5C5.5 10 6.5 9.5 8 9.5C9.5 9.5 10.5 10 11 11.5"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
</template>

<style scoped lang="scss">
.tonality-icon {
  flex-shrink: 0;
}
</style>
